import React, { useState } from 'react'
import { CFooter, CLink } from '@coreui/react-pro'
import { ModalMessage } from '../components'
import CookiePolicy from '../views/pages/policies/CookiePolicy'
import Privacy from '../views/pages/policies/Privacy'

const AppFooter = () => {
  const [showCookiePolicy, setShowCookiePolicy] = useState(false)
  const [showPrivacy, setShowPrivacy] = useState(false)

  return (
    <>
      <CFooter className="px-4 d-flex justify-content-between align-items-center flex-column flex-md-row bg-body-tertiary">
        <div className="fs-7 mb-2 mb-md-0 d-flex flex-column">
          <CLink
            style={{ cursor: 'pointer' }}
            className="text-decoration-none"
            onClick={() => {
              setShowPrivacy(true)
            }}
          >
            Политика обработки персональных данных
          </CLink>
          <CLink
            style={{ cursor: 'pointer' }}
            className="text-decoration-none"
            onClick={() => {
              setShowCookiePolicy(true)
            }}
          >
            Политика в отношении файлов cookie
          </CLink>
        </div>
        <div>2026 &copy; KaneProfessional</div>
      </CFooter>
      <ModalMessage
        message={showCookiePolicy}
        component={<CookiePolicy />}
        onClose={() => setShowCookiePolicy(false)}
        size="xl"
        backdrop="static"
      />
      <ModalMessage
        message={showPrivacy}
        component={<Privacy />}
        onClose={() => setShowPrivacy(false)}
        size="xl"
        backdrop="static"
      />
    </>
  )
}

export default React.memo(AppFooter)
